import {ValueObject} from '@s-ui/domain'

export class UserExistsValueObject extends ValueObject {
  /**
   * @param {Object} data
   * @param {string} data.exists
   * */
}

export const factory = UserExistsValueObject.create
